<template>
  <div class="ModalDialog" v-show="isVisible" @click="close">
    <div class="contentBox" @click.stop>
      <slot />
      <CloseButton @click="close" class="closeButton" />
    </div>
  </div>
</template>

<script>
import CloseButton from '~/vue-components/shared/CloseButton.vue'

export default {
  components: {
    CloseButton,
  },
  props: {
    close: {
      type: Function,
      default: () => {},
    },
    isVisible: {
      type: Boolean,
      default: false,
    },
  },
}
</script>

<style scoped>

@keyframes fadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

.ModalDialog {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 100;
  animation: fadeIn 0.15s both;
}

.contentBox {
  position: relative;
  background: var(--bg-color-white);
  color: var(--text-color-black);
  min-height: 100vh;
  overflow: auto;
}

.closeButton {
  position: absolute;
  top: 1.5rem;
  right: 1rem;
}

@media (--screen-md) {
  .ModalDialog {
    display: flex;
    padding: var(--spacing-8);
    align-items: center;
    justify-content: center;
    background-color: rgba(255, 255, 255, 0.4);
  }

  .contentBox {
    border-radius: 6px;
    box-shadow: 0px 0px 2rem 1rem rgba(0, 0, 0, 0.06);
    box-sizing: border-box;
    width: 42rem;
    min-height: 0;
    max-width: 100%;
    max-height: 100%;
  }
}
</style>
